import Context from '../../common/components/utils/context';
import { Button } from '../components/ui/button'
import { Card } from '../components/ui/cards'
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from '../components/ui/textarea';
import { VideoEmbed } from "../components/ui/video-embed";
import { useToast } from '../hooks/use-toast'
import { useContext, useState } from "react";
import emailjs from "emailjs-com"

export const DemoRequest = () => {
  const context = useContext(Context)
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    message: "",
  });
  const demoForm = {
    "nameLabel": "Name",
    "namePlaceholder": "Your name",
    "emailLabel": "Email",
    "emailPlaceholder": "you@company.com",
    "companyLabel": "Company / Organization",
    "companyPlaceholder": "Your organization",
    "messageLabel": "Tell us about your use case",
    "messagePlaceholder": "What infrastructure assets do you manage? What challenges are you facing?",
    "submitButton": "Request Demo",
    "privacyNotice": "By submitting this form, you agree to our Privacy Policy. We'll use your information only to contact you about FoundAt services.",
    "successTitle": "Demo Request Received",
    "successDescription": "Our team will contact you within 24 hours to schedule your personalized demo."
  }
  const demo = {
    "title": "See FoundAt in Action",
    "subtitle": "Watch our demo video or request a personalized session to discover how GO-Locate AR™ can transform your field operations",
    "videoTitle": "FoundAt GO-Locate AR™ Demo",
    "videoCaption": "See how FoundAt transforms field operations in under 2 minutes",
    "formTitle": "Request a Live Demo"
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    emailjs.send(
      "service_4pnvbyf",
      "template_a4lej12",
      {
        name: formData.name,
        email: formData.email,
        company: formData.company,
        message: formData.message,
      },
      "kpTWZtGbDBRUEDcGL"
    )
    .then(() => console.log("Email sent"))
    .catch((err) => console.error("Email error", err));
      
    // Reset form
    setFormData({ name: "", email: "", company: "", message: "" });
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <section ref={context.homepageSections.demo} id="demo" className="py-20 bg-home-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-home-primary to-home-accent bg-clip-text text-transparent mb-4">
              {demo.title}
            </h2>
            <p className="text-xl text-home-muted-foreground">
              {demo.subtitle}
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
            {/* Video Section */}
            <div className="space-y-4">
              <VideoEmbed 
                videoId="QDmUn6mAhzc" 
                title={demo.videoTitle}
                className="border-2 border-primary/20"
              />
              <p className="text-sm text-home-muted-foreground text-center">
                {demo.videoCaption}
              </p>
            </div>

            {/* Form Section */}
            <Card className="p-8 border-2 border-home-primary">
              <h3 className="text-2xl font-bold text-home-primary mb-6">
                {demo.formTitle}
              </h3>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="name" className="sr-only">{demoForm.nameLabel} *</Label>
                  <Input
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    placeholder={demoForm.namePlaceholder}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="email" className="sr-only">{demoForm.emailLabel} *</Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    placeholder={demoForm.emailPlaceholder}
                  />
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="company" className="sr-only">{demoForm.companyLabel} *</Label>
                <Input
                  id="company"
                  name="company"
                  required
                  value={formData.company}
                  onChange={handleChange}
                  placeholder={demoForm.companyPlaceholder}
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="message" className="sr-only">{demoForm.messageLabel}</Label>
                <Textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder={demoForm.messagePlaceholder}
                  rows={4}
                />
              </div>

              <Button type="submit" variant="hero" size="lg" className="w-full bg-gradient-to-r from-home-primary to-home-accent">
                {demoForm.submitButton}
              </Button>

                <p className="text-sm text-home-muted-foreground text-center sr-only">
                  {demoForm.privacyNotice}
                </p>
              </form>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};
